import validator from "@rjsf/validator-ajv6";
import { Form } from "@rjsf/mui";
import React from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import SearchOnServer from "./formComponents/SearchOnServer";
import DatePicker from "./formComponents/DatePicker";
import { IwdAuthWrapper } from "../../utils/IwdAuthWrapper";
import { useDispatch, useSelector } from "react-redux";
import ModalDialog from "../meters/ModalDialog";
import DtwinCustomField from "./formComponents/DtwinCustomField";
import { useMediaQuery } from "@mui/material";
import { MuiThemeProvider, createTheme } from "@material-ui/core";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { unSetClusterId } from "../../redux/slices/clusterSlice";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { prepareParams, objectFieldTemplate } from "../../utils";
import SaveIcon from "@mui/icons-material/Save";
import MetersTableTab from "./formComponents/MetersTableTab";
import HolidayVillageIcon from "@mui/icons-material/HolidayVillage";
import ExportButton from "./formComponents/ExportButton";
import Table from "./formComponents/Table";
import { setUpdateAfterDelete } from "../../redux/slices/meterSlice";
import theme from "../../theme";
import { setMeterTrashId } from "../../redux/slices/meterSlice";
import { store } from "../../redux/store";
import ErrorsHandler from "../../utils/ErrorsHandler";
import SingleDatePicker from "./formComponents/SingleDatePicker";
import { setBreadCrumbs } from "../../redux/slices/breadCrumbMeterSlice";
import FormAccordion from "./formComponents/Accordion";
import MapDevice from "./formComponents/MapDevice";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useSearchParams } from "react-router-dom";
import {
  Tabs,
  Tab,
  Typography,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Tooltip,
  Button,
} from "@mui/material";

import { Box } from "@mui/system";
import { Grid } from "@mui/material";

const fields = {
  serverSearch: SearchOnServer,
  datepicker: SingleDatePicker,
  dtwin: DtwinCustomField,
};
const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pb: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

const Meters = () => {
  let [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const devices = useSelector((state) => state?.clusterSlice?.devices);
  const updateAfterDelete = useSelector(
    (state) => state?.meterSlice?.updateAfterDelete
  );
  const preferences = useSelector(
    (state) => state?.userPreferenceSlice.preference
  )?.preferences;
  const selectedClusterId = useSelector(
    (state) => state?.clusterSlice?.selectedClusterId
  );
  const userPreferenceFirstRender = useSelector(
    (state) => state?.userPreferenceSlice?.firstRender
  );
  const is1280x720 = useMediaQuery(
    "(max-width: 1280px) and (max-height: 720px)"
  );
  const [getByName, resp, lpi] = store.useLazyGetDataByNameQuery();
  const [getPreference] = store.useLazyGetPreferenceQuery();
  const [refreshParams, setRefreshParams] = useState(false);
  const [meterType, setMeterType] = useState(["AFS"]);
  const [iconHover, setIconHover] = useState(true);
  const [hideAccordion, setHideAccordion] = useState(false);
  const [meterDialogOpen, setMeterDialogOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [preferenceLoading, setPreferenceLoading] = useState();
  const [perPage, setPerPage] = useState(100);
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const [formData, setFormData] = useState({});
  const { t } = useTranslation();
  const appBarIsOpen = useSelector(
    (state) => state?.utilsSlice?.headerAppBarOpen
  );
  const mapCoordinates = resp?.data?.data
    ?.map((item) => item?.attributes?.fields?.coordinates)
    ?.map((item) => item?.coordinates);
  const uiSchema = {
    "ui:submitButtonOptions": {
      submitText: t("search"),
      props: {
        className: "bntListSearch",
        variant: window?.BUTTON_TYPE,
        color: window?.theme?.buttonText,
      },
    },
    "ui:order": [
      "tags",
      "digital_twin_id",
      "network_address",
      "mechanical_serial_number",
      "inserted_at",
      "address",
      "pod",
      "diameter",
      "meter_not_seen",
      "condominium_name",
    ],
    "ui:ObjectFieldTemplate": objectFieldTemplate,
    /*    digital_twin_id: {
      "ui:field": "serverSearch",
    }, */
    digital_twin_id: {
      "ui:field": "dtwin",
    },
    tags: {
      "ui:field": "serverSearch",
    },
    inserted_at: {
      "ui:field": "datepicker",
    },
    condominium_name: {
      "ui:widget": window?.FORM?.blockSecktion,
    },
  };
  const muiTheme = createTheme({
    props: {
      MuiTextField: {
        variant: "outlined",
      },
    },
  });
  useEffect(() => {}, [mapCoordinates]);
  const onIconHover = () => {
    setIconHover(!iconHover);
  };
  useEffect(() => {
    if (userPreferenceFirstRender) {
      getPreference();
    }
  }, []);
  useEffect(() => {}, [meterType]);
  const onCancellClick = () => {
    dispatch(unSetClusterId());
    setIconHover(true);
  };

  const paramsList = {
    digital_twin_id: searchParams.get("digital_twin_id") && [searchParams.get("digital_twin_id").split(",")], // prettier-ignore
    tags: searchParams.get("tags") && [searchParams.get("tags").split(",")],
    /*  from: searchParams.get("from"),
    to: searchParams.get("to"), */
    inserted_at: searchParams.get("inserted_at"),
    network_address: searchParams.get("network_address"),
    mechanical_serial_number: searchParams.get("mechanical_serial_number"),
    address: searchParams.get("address"),
    diameter: searchParams.get("diameter"),
    pod: searchParams.get("pod"),
    page: page,
    per_page: 12,
    in_error: searchParams.get("in_error"),
    meter_not_seen: searchParams.get("meter_not_seen"),
    meter_types: JSON.stringify(meterType),
    condominium_name: searchParams.get("condominium_name"),

    //TODO: remove it, added only for demo propouse
    /*  class: "AltiorEdge", */
  };

  useEffect(() => {
    localStorage.removeItem("alarm_date");
  }, []);

  useEffect(() => {
    if (refreshParams) {
      getByName(["altior/device", { ...paramsList }]);
      setRefreshParams(false);
    }
  }, [refreshParams, page]);
  useEffect(() => {
    if (updateAfterDelete) {
      getByName(["altior/device", { ...paramsList }]);
      dispatch(setUpdateAfterDelete(false));
    }
  }, [updateAfterDelete]);
  useEffect(() => {}, [hideAccordion]);

  useEffect(() => {
    dispatch(setBreadCrumbs("Meters"));
    return () => {
      dispatch(setBreadCrumbs(null));
    };
  }, []);

  const customValidate = (formData, errors) => {
    if (formData?.insertion_date?.from && formData.insertion_date?.to) {
      if (
        formData?.insertion_date?.from !== "" &&
        formData?.insertion_date?.to !== "" &&
        formData?.insertion_date?.from >= formData?.insertion_date?.to
      ) {
        errors?.insertion_date?.to.addError(t("date_error"));
      }
    } else {
      if (formData?.insertion_date?.from && !formData?.insertion_date?.to) {
        errors?.insertion_date?.to.addError(t("missing_endDate"));
      }
      if (!formData?.insertion_date?.from && formData?.insertion_date?.to) {
        errors?.insertion_date?.from?.addError(t("missing_startDate"));
      }
    }

    return errors;
  };
  const onAccordionClick = () => {
    setHideAccordion(!hideAccordion);
  };
  const onSubmitClick = (obj) => {
    obj["page"] = page;
    obj["per_page"] = perPage;

    const params = prepareParams(obj);
    navigate({
      pathname: "/meters",
      search: params.toString(),
    });

    setPage(1);
    setRefreshParams(true);
  };

  useEffect(() => {
    getByName(["altior/device", { ...paramsList }]);
  }, [page, meterType]);
  const handleChange = (event, newValue) => {
    if (newValue !== 2) {
      setValue(newValue);
    }
  };
  useEffect(() => {
    dispatch(setMeterTrashId(null));
  }, []);
  const diameterEnum = [
    { label: "--", value: "" },
    { label: "DN6", value: "DN6" },
    { label: "DN8", value: "DN8" },
    { label: "DN10", value: "DN10" },
    { label: "DN15", value: "DN15" },
    { label: "DN20", value: "DN20" },
    { label: "DN25", value: "DN25" },
    { label: "DN32", value: "DN32" },
    { label: "DN40", value: "DN40" },
    { label: "DN50", value: "DN50" },
    { label: "DN65", value: "DN65" },
    { label: "DN80", value: "DN80" },
    { label: "DN90", value: "DN90" },
    { label: "DN100", value: "DN100" },
    { label: "DN125", value: "DN125" },
    { label: "DN150", value: "DN150" },
    { label: "DN200", value: "DN200" },
    { label: "DN250", value: "DN250" },
    { label: "DN300", value: "DN300" },
    { label: "DN350", value: "DN350" },
    { label: "DN400", value: "DN400" },
    { label: "DN450", value: "DN450" },
    { label: "DN500", value: "DN500" },
    { label: "DN550", value: "DN550" },
    { label: "DN600", value: "DN600" },
    { label: "DN650", value: "DN650" },
    { label: "DN700", value: "DN700" },
    { label: "DN750", value: "DN750" },
    { label: "DN800", value: "DN800" },
    { label: "DN900", value: "DN900" },
    { label: "DN1000", value: "DN1000" },
    { label: "DN1050", value: "DN1050" },
    { label: "DN1200", value: "DN1200" },
    { label: "DN1400", value: "DN1400" },
    { label: "DN1600", value: "DN1600" },
    { label: "DN1800", value: "DN1800" },
    { label: "DN2000", value: "DN2000" },
    { label: "DN2200", value: "DN2200" },
    { label: "DN2400", value: "DN2400" },
    { label: "DN2500", value: "DN2500" },
    { label: "DN2600", value: "DN2600" },
    { label: "DN2700", value: "DN2700" },
  ];

  const notseenEnum = [
    { value: "", label: "--" },
    { value: "7", label: t("7_days") },
    { value: "30", label: t("30_days") },
    { value: "90", label: t("90_days") },
  ];

  const schema = {
    type: "object",
    properties: {
      tags: {
        id: 0,
        type: "array",
        url: "tag",
        title: t("Tag"),
        default: paramsList.tags,
        multiple: true,
        properties: {
          tags: {
            type: "number",
          },
        },
      },

      digital_twin_id: {
        $id: "7",

        mapFn: (result) =>
          result?.data?.data
            ?.map((item) => ({
              key: item.attributes?.id,
              label: `${item.attributes?.name} (${item.attributes?.version})`,
              value: `${item.attributes?.name} (${item.attributes?.version})`,
              tags: item?.attributes?.digital_twin_fields?.tags,
            }))
            ?.filter(
              (item) =>
                item?.tags?.includes("Meter") || item?.tags?.includes("meter")
            ),

        url: "altior/digital_twin",
        type: "string",
        title: t("digital_twin"),
        fromIndex: true,
        dispatched: true,
        checkbox: true,
      },
      network_address: {
        id: 2,
        title: t("network_address"),
        type: "string",
        default: paramsList.network_address,
      },
      condominium_name: {
        id: 2,
        title: t("condominium"),
        type: "string",
        default: paramsList.condominium_name,
        hide: true,
      },

      mechanical_serial_number: {
        id: 2,
        title: t("metrological_serial"),
        type: "string",
        default: paramsList?.mechanical_serial_number,
      },
      inserted_at: {
        id: 3,
        title: t("configuration_date"),
        type: "object",
        type: "string",
        label: "configuration_date",
        default: paramsList.inserted_at,
      },
      address: {
        id: 4,
        type: "string",
        title: t("street_address"),
        default: paramsList.address,
      },
      pod: {
        id: 5,
        type: "string",
        title: t("pod"),
        default: paramsList.pod,
      },
      diameter: {
        id: 6,
        type: "string",
        title: t("diameter"),
        oneOf: diameterEnum.map((option) => ({
          const: option.value,
          title: option.label,
        })),
        default: paramsList.diameter,
      },
      meter_not_seen: {
        type: "string",
        title: t("not_seen"),
        enum: notseenEnum?.map((option) => option.value),
        enumNames: notseenEnum?.map((option) => option.label),
        default: paramsList.meter_not_seen,
      },
    },
  };
  const dinamicWidthSelector = () => {
    if (is1280x720 && appBarIsOpen) {
      return 1330;
    }
    if (is1280x720 && appBarIsOpen) {
      return 1272;
    }
    if (is1280x720 && !appBarIsOpen) {
      return 1714;
    }
    if (is1280x720 && !appBarIsOpen) {
      return 1426;
    }

    if (!is1280x720 && appBarIsOpen) {
      return 1550;
    }
    if (!is1280x720 && !appBarIsOpen) {
      return 1770;
    }
  };
  return (
    <Box sx={{ flexGrow: 1, margin: 0 }}>
      <ModalDialog
        open={meterDialogOpen}
        close={() => setMeterDialogOpen(false)}
      >
        <Box>
          In this form it is possible to filter the devices present in the
          registry. All filters are applied in and between them. Description of
          the filters.
          <ul>
            <li>
              <b>Tag:</b> devices are filtered by inserted tag, for example:
              residential_meters Digital Twin: devices are filtered by type of
              meter / sensor / valve
            </li>
            <li>
              <b>Serial:</b> devices are filtered for the serial (S / N) of the
              device, or part of it
            </li>
            <li>
              <b>Start and End Data:</b> the devices are filtered by date of
              insertion into the system
            </li>
            <li>
              <b>Street address:</b> the devices are filtered by the address
              entered
            </li>
            <li>
              <b>POD:</b> devices are filtered by POD{" "}
            </li>
            <li>
              <b>Diameter:</b> the devices are filtered bythe diameter chosen
              from those selectable
            </li>
          </ul>
        </Box>
      </ModalDialog>
      <IwdAuthWrapper
        children={
          <Box display={"flex"} width={"100%"} justifyContent={"flex-end"}>
            <Button
              variant={window.BUTTON_TYPE}
              sx={{
                mt: 1,
              }}
              onClick={() => navigate("/meters/create")}
            >
              {t("new_meter")}
            </Button>
          </Box>
        }
        section={"add_meter_btn"}
      />
      <FormAccordion
        onClick={onAccordionClick}
        icon={
          <HelpOutlineIcon
            sx={{ float: "right" }}
            onClick={(e) => {
              e.stopPropagation();
              setMeterDialogOpen(true);
            }}
          />
        }
        width={"100%"}
      >
        <Form
          schema={schema}
          fields={fields}
          formData={formData}
          customValidate={customValidate}
          showErrorList={false}
          onChange={(changeEvent) => setFormData(changeEvent.formData)}
          validator={validator}
          uiSchema={uiSchema}
        >
          <Button
            variant={window.BUTTON_TYPE}
            type="submit"
            sx={{ mt: 1, float: "right" }}
            onClick={() => onSubmitClick(formData)}
          >
            {t("search")}
          </Button>
          <ExportButton
            styleProp={{ float: "right", mr: 2, mt: 1 }}
            paramsList={{ ...formData }}
          />
        </Form>
      </FormAccordion>
      <Box sx={{ mt: 1, mb: 4 }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label={t("table")} />
          <Tab label={t("map")} disabled={!preferences} />
          {selectedClusterId !== "" && (
            <Tab
              label={
                iconHover ? (
                  <CheckCircleOutlineIcon sx={{ fill: "green" }} />
                ) : (
                  <Tooltip title="unset cluster">
                    <HighlightOffIcon sx={{ fill: "red" }} />
                  </Tooltip>
                )
              }
              onMouseEnter={onIconHover}
              onMouseLeave={onIconHover}
              onClick={onCancellClick}
            />
          )}
          {preferenceLoading && (
            <Tab
              label={
                <Tooltip title="saving user preference">
                  <SaveIcon sx={{ fill: "green" }} />
                </Tooltip>
              }
            />
          )}
        </Tabs>
        <TabPanel value={value} index={0}>
          <MetersTableTab
            afs={
              <Table
                data={devices?.data ? devices?.data : resp?.data?.data}
                response={resp}
                perPage={12}
                page={page}
                setPage={setPage}
                hideAccordion={hideAccordion}
              />
            }
            heatMeter={
              <Table
                data={devices?.data ? devices?.data : resp?.data?.data}
                response={resp}
                perPage={12}
                page={page}
                setPage={setPage}
                hideAccordion={hideAccordion}
              />
            }
            colorMeter={
              <Table
                data={devices?.data ? devices?.data : resp?.data?.data}
                response={resp}
                perPage={12}
                page={page}
                setPage={setPage}
                hideAccordion={hideAccordion}
              />
            }
            setMeterType={setMeterType}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <MapDevice
            pos={mapCoordinates}
            hideAccordion={hideAccordion}
            setPreferenceLoading={setPreferenceLoading}
            params={paramsList}
          />
        </TabPanel>
      </Box>
    </Box>
  );
};

export default React.memo(Meters);
